/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {BundlesRoutingModule} from './bundles-routing.module';
import {BundlesMainPageModule} from './bundles-main-page/bundles-main-page.module';

@NgModule({
    imports: [
        BundlesRoutingModule,
        BundlesMainPageModule
    ]
})

export class BundlesModule {
}

